import visa1 from "../data/pt_visa_1_ques.json";
import visa2 from "../data/pt_visa_2_ques.json";
import visa3 from "../data/pt_visa_3_ques.json";
import visa4 from "../data/pt_visa_4_ques.json";
import visa5 from "../data/pt_visa_5_ques.json";

export const visaQuestionMap = {
  1: visa1.questions,
  2: visa2.questions,
  3: visa3.questions,
  4: visa4.questions,
  5: visa5.questions
};
